
import VueOfficeView from "@/components/VueOfficeView.vue";
export const mixinPreview = {
  components: {
    VueOfficeView
  },
  data() {
    return {
      fileType: 0,
      fileUrl: "",
      fileName: "",
    }
  },
  methods:{
    // 预览
    handlePreview(data) {
      console.log(data,"data");
      let row =  {
        ...data,
        url: data.url || data.file,
      } 
      let _suffix = row.name.substr(row.name.lastIndexOf("."));
      console.log(_suffix);
      if (
        _suffix == ".pdf" ||
        _suffix == ".ppt" ||
        _suffix == ".mp3" ||
        _suffix == ".mp4" ||
        _suffix == ".jpeg" ||
        _suffix == ".jpg" ||
        _suffix == ".png" ||
        _suffix == ".gif"
      ) {
        window.open(row.url, "_blank");
        return;
      } else if (_suffix == ".xlsx" || _suffix == ".xls") {
        this.fileType = 5;
      } else if (_suffix == ".docx" || _suffix == ".doc") {
        this.fileType = 2;
      } else if(_suffix == ".ofd") {
        this.fileType = 6;
      } else {
        return;
      }
      // // return
      this.fileUrl = row.url;
      this.fileName = row.name;
      let dom = this.$refs.fileView;
      console.log(dom, "dom");
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
  }
}